function scIsNight(date) {
  const h = date.getHours();
  return h >= 18 || h < 6;
}

function scUpdateThemeIcons() {
  const root = document.getElementById("scContainer");
  const isDark = root.classList.contains("sc-dark");
  document.getElementById("sc-icon-moon").style.display = isDark ? "none" : "block";
  document.getElementById("sc-icon-sun").style.display = isDark ? "block" : "none";
  document.getElementById("scIcon").innerHTML = isDark ? "🌙 Sleep Cycle Calculator" : "☀️ Sleep Cycle Calculator";
}

function scApplyTheme() {
  const root = document.getElementById("scContainer");
  if (!root) return;
  const night = scIsNight(new Date()); 
  if (night) {
    root.classList.add("sc-dark");
  } else {
    root.classList.remove("sc-dark");
  }
  scUpdateThemeIcons();
}

function scToggleTheme() {
  const root = document.getElementById("scContainer");
  if (root) {
    root.classList.toggle("sc-dark");
    scUpdateThemeIcons();
  }
}

function scFormatTimeObj(date) {
  let h = date.getHours();
  let m = date.getMinutes();
  let ampm = h >= 12 ? 'PM' : 'AM';
  h = h % 12 || 12;
  m = m < 10 ? '0' + m : m;
  return { time: `${h}:${m}`, period: ampm };
}

function scCalcSleep() {
  const hInput = parseInt(document.getElementById("scHour").value);
  const mInput = parseInt(document.getElementById("scMinute").value);
  const ampm = document.getElementById("scAmPm").value;

  let h = hInput;
  if (ampm === "PM" && h !== 12) h += 12;
  if (ampm === "AM" && h === 12) h = 0;

  let base = new Date();
  base.setHours(h, mInput, 0);

  const inputTime = scFormatTimeObj(base);
  const inputIcon = scIsNight(base) ? '🌙' : '☀️';

  const cyclesDiv = document.getElementById("scCycles");
  const othersDiv = document.getElementById("scOthers");
  const resultArea = document.getElementById("scResultArea");
  
  resultArea.style.display = "block";
  cyclesDiv.innerHTML = "";
  othersDiv.innerHTML = "";

  for (let i = 3; i <= 7; i++) {
    let totalMins = (i * 90); 
    let hrs = Math.floor(totalMins / 60);
    let mins = totalMins % 60;
    let durationStr = `${hrs}h ${mins > 0 ? mins + 'm' : '00m'}`;
    
    let t = new Date(base.getTime() + (totalMins + 15) * 60000);
    let outTime = scFormatTimeObj(t);
    let outIcon = scIsNight(t) ? '🌙' : '☀️';

    if (i === 5 || i === 6) {
      let isBest = (i === 5);
      cyclesDiv.innerHTML += `
        <div class="sc-box ${isBest ? 'sc-best' : ''}">
          ${isBest ? '<div class="sc-best-tag">👑 BEST</div>' : ''}
          <div class="sc-box-data">
            <div class="sc-time-block">
              <div class="sc-t-icon">${inputIcon}</div>
              <p class="sc-t-label">Bedtime</p>
              <p class="sc-t-time">${inputTime.time}<span>${inputTime.period}</span></p>
            </div>
            <div class="sc-t-sep">
              <svg viewBox="0 0 64 2" fill="none"><path d="M1 1H63" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-dasharray="4 4"></path></svg>
            </div>
            <div class="sc-time-block">
              <div class="sc-t-icon">${outIcon}</div>
              <p class="sc-t-label">Wake up</p>
              <p class="sc-t-time">${outTime.time}<span>${outTime.period}</span></p>
            </div>
          </div>
          <div class="sc-total-time"><b>${durationStr}</b> Bedtime (${i} Sleep Cycles)</div>
        </div>
      `;
    } else {
      othersDiv.innerHTML += `
        <div class="sc-other-card">
          <div class="sc-other-icon">${outIcon}</div>
          <div class="sc-other-info">
            <span class="sc-other-time-text">${outTime.time} ${outTime.period}</span>
            <span class="sc-other-cycle-text">${i} sleep cycles (${durationStr})</span>
          </div>
        </div>
      `;
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  scApplyTheme();
  const themeBtn = document.getElementById("scThemeBtn");
  if (themeBtn) themeBtn.addEventListener("click", scToggleTheme);
  const calcBtn = document.getElementById("scCalcBtn");
  if (calcBtn) calcBtn.addEventListener("click", scCalcSleep);
});